<script setup>
import { ref } from 'vue';
import RevisionModal from "@/components/approval-center/modals/RevisionModal.vue";
import LoadingModal from "@/components/approval-center/modals/LoadingModal.vue";
import useApprovalFlow from "@/composables/approval-center/useApprovalFlow";
import ExtraHelpModal from "@/components/approval-center/modals/ExtraHelpModal.vue";

const feedbackValue = defineModel('feedback', {
  type: String,
  required: true,
});

defineProps({
  loading: {
    type: Boolean,
    required: true
  },
});

const emit = defineEmits(['close', 'continue', 'confirm']);
const showLoadingModal = ref(false);
const showExtraHelpModal = ref(false);

const {revisionErrors: errors} = useApprovalFlow();

const handleConfirm = () => {
  showLoadingModal.value = true;
  emit('confirm');
};

const handleContinue = () => {
  showLoadingModal.value = false;
  emit('continue');
}
</script>

<template>
  <RevisionModal
    v-if="(!showLoadingModal && !showExtraHelpModal) || errors"
    v-model="feedbackValue"
    @close="emit('close')"
    @extra-help="showExtraHelpModal = true"
    @confirm="handleConfirm"
  />

  <ExtraHelpModal
    v-else-if="showExtraHelpModal"
    @close="emit('close')"
  />

  <LoadingModal
    v-else
    :loading="loading"
    @continue="handleContinue"
  />
</template>
